// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OQHl","content":"styles_content__81OQp"};